import { useDocumentPermission } from '../../context/DocumentPermissionContext';

interface OriginalFileNameLabelProps {
  originalFileName: string | null | undefined;
  className?: string;
}

/** Shows the original file name only to admin users when a value is present. */
export function OriginalFileNameLabel({ originalFileName, className }: OriginalFileNameLabelProps) {

  const { isAdmin } = useDocumentPermission();

  if (!isAdmin || !originalFileName) return null;

  return (
    <p className={`text-onsurface/70 text-sm truncate font-bold ${className ?? ''}`}>
      {originalFileName}
      {/* {t('documents.detail.fileObjects.originalFileName', { name: originalFileName })} */}
    </p>
  );
}
